var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trash",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 18",
    enableBackground: "new 0 0 15 18",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash_1_",
    transform: "translate(495.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-483.2266,7h-8.501c-1.2236,0-2.2188-0.9229-2.2192-2.0566L-494-5.4976c-0.0005-0.1328,0.0518-0.2607,0.1455-0.355 S-493.6328-6-493.5-6h11.9463c0.2754,0,0.499,0.2222,0.5,0.4976L-481,4.9395C-481,6.0771-481.999,7-483.2266,7z M-492.9976-5 l0.0508,9.9395c0,0.001,0,0.002,0,0.0029c0,0.5732,0.5581,1.0576,1.2192,1.0576h8.501C-482.5615,6-482,5.5156-482,4.9424 L-482.0508-5H-492.9976z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-480.5-5h-14c-0.2764,0-0.5-0.2236-0.5-0.5v-3c0-0.2764,0.2236-0.5,0.5-0.5h14c0.2764,0,0.5,0.2236,0.5,0.5v3 C-480-5.2236-480.2236-5-480.5-5z M-494-6h13v-2h-13V-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-484.5-8h-6c-0.2764,0-0.5-0.2236-0.5-0.5v-2c0-0.2764,0.2236-0.5,0.5-0.5h6c0.2764,0,0.5,0.2236,0.5,0.5v2 C-484-8.2236-484.2236-8-484.5-8z M-490-9h5v-1h-5V-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-484.5,4c-0.2764,0-0.5-0.2236-0.5-0.5v-6c0-0.2764,0.2236-0.5,0.5-0.5s0.5,0.2236,0.5,0.5v6 C-484,3.7764-484.2236,4-484.5,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-487.5,4c-0.2764,0-0.5-0.2236-0.5-0.5v-6c0-0.2764,0.2236-0.5,0.5-0.5s0.5,0.2236,0.5,0.5v6 C-487,3.7764-487.2236,4-487.5,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-490.5,4c-0.2764,0-0.5-0.2236-0.5-0.5v-6c0-0.2764,0.2236-0.5,0.5-0.5s0.5,0.2236,0.5,0.5v6 C-490,3.7764-490.2236,4-490.5,4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnTrash);
export default __webpack_public_path__ + "static/media/BtnTrash.51956772931a40cca51f478ec8189a3d.svg";
export { ForwardRef as ReactComponent };